import { render, staticRenderFns } from "./MyDrafts.vue?vue&type=template&id=447b3a06"
import script from "./MyDrafts.vue?vue&type=script&lang=js"
export * from "./MyDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports